import { routesPath } from '@router/routes';
import { Layout } from '@components/Layout/Layout';
import { QCList } from '../pages/QC/QCList/QCList';
import { QCTask } from '../pages/QC/QCTask/QCTask';
import { UserRoles } from '@dynamika-shared/types/auth';
import { WithUserRolesHoc } from '@components/HOC/WithUserRoles/WithUserRoles.hoc';
import { SiteUserLayout } from '@components/SiteUserLayout/SiteUserLayout';
import { SelectClinicalTrialForRole } from '@components/LoginSelections/SelectClinicalTrialForRole';
import { QcMenu } from '@components/Sidebar/Menu/QCMenu/QCMenu';
import { QCViewer } from '../pages/QC/QCVisit/QCViewer';
import { DXAPage } from 'src/pages/QC/DXA/DXAPage';
import { QCTPage } from 'src/pages/QC/QCT/QCTPage';
import { QCQueries } from 'src/pages/QC/QCQueries/QCQueries';
import { QCQueryPage } from 'src/pages/QC/QCQueryPage/QCQueryPage';

export const QCRoutes = [
  {
    path: routesPath.qc,
    element: (
      <WithUserRolesHoc allowedRoles={[UserRoles.IMAGING_SPECIALIST]}>
        <SiteUserLayout>
          <SelectClinicalTrialForRole />
        </SiteUserLayout>
      </WithUserRolesHoc>
    ),
  },
  {
    path: routesPath.qcTasks,
    element: (
      <WithUserRolesHoc allowedRoles={[UserRoles.IMAGING_SPECIALIST]}>
        <Layout menuComponent={QcMenu}>
          <QCList />
        </Layout>
      </WithUserRolesHoc>
    ),
  },
  {
    path: routesPath.qcQueries,
    element: (
      <WithUserRolesHoc allowedRoles={[UserRoles.IMAGING_SPECIALIST]}>
        <Layout menuComponent={QcMenu}>
          <QCQueries />
        </Layout>
      </WithUserRolesHoc>
    ),
  },
  {
    path: routesPath.qcQuery,
    element: (
      <WithUserRolesHoc allowedRoles={[UserRoles.IMAGING_SPECIALIST]}>
        <Layout menuComponent={QcMenu}>
          <QCQueryPage />
        </Layout>
      </WithUserRolesHoc>
    ),
  },
  {
    path: routesPath.qcTaskInfo,
    element: (
      <WithUserRolesHoc allowedRoles={[UserRoles.IMAGING_SPECIALIST]}>
        <Layout menuComponent={QcMenu}>
          <QCTask />
        </Layout>
      </WithUserRolesHoc>
    ),
  },
  {
    path: routesPath.qcTaskDXA,
    element: (
      <WithUserRolesHoc allowedRoles={[UserRoles.IMAGING_SPECIALIST]}>
        <Layout menuComponent={QcMenu}>
          <DXAPage />
        </Layout>
      </WithUserRolesHoc>
    ),
  },
  {
    path: routesPath.qcTaskQCT,
    element: (
      <WithUserRolesHoc allowedRoles={[UserRoles.IMAGING_SPECIALIST]}>
        <Layout menuComponent={QcMenu}>
          <QCTPage />
        </Layout>
      </WithUserRolesHoc>
    ),
  },
  {
    path: routesPath.qcTaskViewer,
    element: (
      <WithUserRolesHoc allowedRoles={[UserRoles.IMAGING_SPECIALIST]}>
        <QCViewer />
      </WithUserRolesHoc>
    ),
  },
];
